require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./content-type-sandbox-sample-embedded-page-photo-with-overlay.json") })
        }
      }, "path---content-type-sandbox-sample-embedded-page-photo-with-overlay");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---content-type-sandbox-sample-embedded-page-photo-with-overlay!./.cache/json/content-type-sandbox-sample-embedded-page-photo-with-overlay.json
// module id = 1994
// module chunks = 231608221292675